import { useState, useEffect } from "react";

export const useLocalStorage = (keyName, defaultValue) => {

  const [storedValue, setStoredValue] = useState(   () => {
    try {
      const value =   window.localStorage.getItem(keyName);
     
      if (value) {
        return JSON.parse(value);
      } else {
        window.localStorage.setItem(keyName, JSON.stringify(defaultValue));
        return defaultValue;
      }
    } catch (err) {
      return defaultValue;
    }
  });

  const setValue = async(newValue) => {
    try {
      window.localStorage.setItem(keyName, JSON.stringify(newValue));
    } catch (err) {}
    setStoredValue(newValue);
  };

 /*  const getToken = async ()=>{
    setToken(await storedValue ?.api_token)
  } */

  return [storedValue, setValue];
};
